<template>
  <div id="analysis-landing">
    <section id="project-content">
      <Breadcrumb v-bind:crumbs="breadcrumbs" />
    </section>

    <form
      target="analysisIframe"
      v-bind:action="iframeUrl"
      method="post"
      ref="iframeRef"
    >
      <input type="hidden" name="token" v-bind:value="token" />
      <input type="hidden" name="lang" v-bind:value="lang" />
    </form>
    <iframe
      name="analysisIframe"
      v-if="iframeUrl !== ''"
      v-bind:title="$t('views.analysis.title')"
      id="analysis-window"
      width="100%"
      height="100%"
      v-on:load="scrollDown()"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";

import { projectService } from "@/services/project.service";

export default {
  name: "Project",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      project: {},
      breadcrumbs: [],
      iframeUrl: "",
      token: "",
      lang: "",
    };
  },
  created: function () {
    this.checkWhitelistAccess();
  },
  methods: {
    scrollDown: function () {
      window.scrollTo(0, 125);
    },
    fetchProject: function () {
      // grab the project
      projectService
        .getProject(this.$route.params.projectId)
        .then((project) => {
          this.project = project;
          if (!project.enabled) {
            this.$router.push("/plan/" + project.planId);
          } else {
            // Build up the Breadcrumb
            this.breadcrumbs.push({
              name: project.planName,
              link: "/plan/" + project.planId,
            });
            this.breadcrumbs.push({
              name: project.groupName,
              link: "/group/" + project.groupId,
            });
            this.breadcrumbs.push({
              name: project.name,
              link: "/project/" + project.id,
            });
            this.breadcrumbs.push({
              name: this.$t("views.analysis.breadcrumb"),
              starFlag: true,
            });
          }
        })
        .catch((err) => {
          console.error("something went wrong fetching project: ", err);
        });
    },
    fetchProjectUrl: function () {
      // grab the project url
      projectService
        .getProjectUrl(
          this.$route.params.projectId,
          this.$route.params.moduleId
        )
        .then((res) => {
          this.iframeUrl = res.url;
          this.token = res.token;
          this.lang = this.$i18n.locale;
          this.$nextTick(() => this.$refs.iframeRef.submit());
        })
        .catch((err) => {
          console.error("something went wrong fetching project url: ", err);
          this.$router.push("/plans");
        });
    },
    checkWhitelistAccess: function () {
      projectService
        .whitelistAccess(this.$route.params.projectId)
        .then((res) => {
          if (res) {
            this.fetchProject();
            this.fetchProjectUrl();
          } else {
            this.$router.push("/error?err=403");
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
main {
  position: relative;
}

nav.breadcrumb {
  margin: 22px auto;
}

#analysis-landing {
  position: absolute;
  top: 50;
  height: 100%;
  width: 100%;
}

iframe {
  border: none;
  height: 100%;
}
</style>
